import { createSlice } from '@reduxjs/toolkit'

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    isFullscreen: false,
    showFullscreenOption: true
  },
  reducers: {
    toggleModalFullscreen: (state, data) => {
      return { ...state, isFullscreen: data.payload }
    },
    toggleModalFullscreenOption: (state, data) => {
      return { ...state, showFullscreenOption: data.payload }
    }
  }
})

export const { toggleModalFullscreen, toggleModalFullscreenOption } = modalSlice.actions

export default modalSlice.reducer
